const nativeFieldKeys = {
  'Native Ad Linkset Link': ['title', 'logo', 'byline'],
  'Native Ad Content Link': ['title', 'byline', 'logo', 'thumbnail', 'eyebrow', 'description'],
  'Native Ad Latest': ['thumbnail', 'sponsored_logo', 'title', 'description', 'preamble'],
  'Native Ad Linkset 2.0': ['title', 'logo', 'byline'],
  'Native Ad Content Link 2.0': ['title', 'byline', 'logo', 'thumbnail', 'eyebrow', 'description'],
  'Native Ad Latest 2.0': ['thumbnail', 'sponsored_logo', 'title', 'description', 'preamble'],
  'Native Ad Fan Post': ['cta', 'brand_name', 'small_thumbnail', 'large_thumbnail', 'logo', 'text', 'title'],
};

export default {
  listenForHymnalRenderEvents(app) {
    document.addEventListener('hymnal_render', e => {
      if (!e.detail) {
        return false;
      }
      var ad = e.detail.ad;

      if (ad.type.includes('Native Ad')) {
        if (app.settings.repository === 'duet' && Object.keys(nativeFieldKeys).includes(ad.design_template)) {
          this.renderAdByReplacingContent(ad, nativeFieldKeys[ad.design_template]);
        } else if (ad.design_template && ad.design_template.includes('Native Ad Latest')) {
          this.renderLatestNative(ad);
        } else if (ad.design_template && ad.design_template.includes('Native Ad Content Link')) {
          this.renderContentLink(ad);
        }

        if (ad.trackElement) {
          ad.trackElement(ad._element[0]);
        }
      }
    });
  },

  renderAdByReplacingContent(ad = null, fieldKeys) {
    // Unclear if we still need this
    if (!('remove' in Element.prototype)) {
      Element.prototype.remove = function() {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }

    const fields = ad.fields;
    const containerSelector = adDataSelector('container');
    const adIframeParent = findAdIframeParent(ad._element[0]);
    const adContainer = findParent(adIframeParent, containerSelector);
    const logoKeys = findKeys(fieldKeys, 'logo');
    const thumbnailKeys = findKeys(fieldKeys, 'thumbnail');

    removeElemIfPresent(adContainer, containerSelector);
    removeElemIfPresent(adContainer, 'svg');

    const wrappedClickthroughUrl = getWrappedClickthrough(ad);
    [...adContainer.querySelectorAll('a')].forEach(a => a.setAttribute('href', wrappedClickthroughUrl));

    const textFieldKeys = fieldKeys.filter(key => !key.includes('logo') && !key.includes('thumbnail'));

    textFieldKeys.forEach(fieldKey => {
      const removeIfBlank = fieldKey === 'eyebrow' ? true : false;
      const fieldValue =
        fieldKey === 'byline'
          ? `Advertiser Content From ${fields[fieldKey] ? fields[fieldKey] : ''}`
          : fields[fieldKey];

      // Only apply fieldValue if it isn't empty
      if (fieldValue && fieldValue !== '') {
        applyText(adContainer, adDataSelector(fieldKey), fieldValue, removeIfBlank);
      }
    });

    if (logoKeys.length > 0) {
      logoKeys.forEach(logoKey => {
        updateLogo(adContainer, fields, logoKey);
      });
    }

    if (thumbnailKeys.length > 0) {
      thumbnailKeys.forEach(thumbnailKey => {
        updateThumbnail(adContainer, fields, thumbnailKey);
      });
    }

    makeSponsorClickable(ad);
    adContainer.classList.remove('hidden');
  },

  renderContentLink(ad = null) {
    // omg IE i hate you
    if (!('remove' in Element.prototype)) {
      Element.prototype.remove = function() {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }

    var adIframeParent = findAdIframeParent(ad._element[0]);
    var adContainer = findParent(adIframeParent, adDataSelector('container'));
    var fields = ad.fields;

    removeElemIfPresent(adContainer, adDataSelector('container'));
    removeElemIfPresent(adContainer, 'svg');

    const wrappedClickthroughUrl = getWrappedClickthrough(ad);
    [...adContainer.querySelectorAll('a')].forEach(a => a.setAttribute('href', wrappedClickthroughUrl));

    var byline = (fields.preamble || 'Advertiser Content From') + ' ' + fields.byline;
    applyText(adContainer, adDataSelector('byline'), byline);
    applyText(adContainer, adDataSelector('description'), fields.description);
    applyText(adContainer, adDataSelector('eyebrow'), fields.eyebrow || '', true);
    applyText(adContainer, adDataSelector('headline'), fields.title);

    [...adContainer.querySelectorAll(adDataSelector('preamble_bg'))].forEach(el => {
      el.style.backgroundColor = fields.brand_color;
    });

    [...adContainer.querySelectorAll(adDataSelector('thumbnail'))].forEach(thumbnail => {
      thumbnail.classList.remove('lazy-image', 'vox-lazy-load', 'lazy-loaded');
      thumbnail.src = fields.thumbnail;
      thumbnail.setAttribute('data-original', fields.thumbnail);
      thumbnail.alt = fields.description;
      thumbnail.style.cssText =
        'background-image:url(' + fields.thumbnail + '); background-size: cover; background-repeat:no-repeat;';
    });

    [...adContainer.querySelectorAll(adDataSelector('logo'))].forEach(logo => {
      logo.src = fields.logo;
      logo.alt = fields.description;
    });

    makeSponsorClickable(ad);
  },

  // The Latest Native is served in a slot below the list of items
  // this code places the slot in the list at the defined position
  // or at the very end if there's no position/ fewer items than the position calls for
  renderLatestNative(ad) {
    var adSlot = ad._element[0];
    var adIframeParent = findAdIframeParent(adSlot);
    // convert string to integer
    var location = parseInt(ad.fields.position, 10);
    location = isNaN(location) ? 5 : location;

    // [class*=c-rock-list] looks for any element that has the prefix of .c-rock-list, doing this to support other networks having different selectors but have the prefix of "c-rock-list"
    var container = findParent(adIframeParent, '[class*=c-rock-list]');
    var list = container.querySelector('[class*=list]');
    var items = list.querySelectorAll('li');

    // it offends me to put a div in an ol element so i'm wrapping this in a li
    var wrapper = document.createElement('li');
    wrapper.appendChild(adSlot);

    // if we can put it in the specified location, do so, otherwise put it at the end
    if (items.length > location) {
      list.insertBefore(wrapper, items[location]);
      items[location].remove();
    } else {
      // if that doesn't exist
      list.appendChild(wrapper);
    }
  },
};

function adDataSelector(id) {
  return `[data-native-ad-id="${id}"]`;
}

// helper function that walks through parent elements until a selector is met
function findParent(node, selector) {
  var el = false;
  var parent = node.parentNode;
  while (!el) {
    if (parent && parent.matches(selector)) {
      el = parent;
    } else {
      parent = parent.parentNode;
    }
  }
  return el;
}

// Find the parent node of the ad iframe element
// If it's not inside an iframe, just return the slot
function findAdIframeParent(adSlot) {
  const currentWindow = getOwnerWindow(adSlot);
  return currentWindow?.frameElement?.parentNode || adSlot;
}

// Get the current window that the node is within
function getOwnerWindow(node) {
  return node.ownerDocument?.defaultView || node.ownerDocument?.parentWindow;
}

function removeElemIfPresent(adSlot, selector) {
  [...adSlot.querySelectorAll(selector)].forEach(el => el.remove());
}

function applyText(adSlot, selector, data, removeIfBlank) {
  [...adSlot.querySelectorAll(selector)].forEach(el => {
    el.innerText = data;
    if (!!removeIfBlank && data.trim().length == 0) el.remove();
  });
}

// Pass in an ad and a selector if you want to override
// the default selector of `.native-ad-sponsorship`
function makeSponsorClickable(ad, selector) {
  selector = selector || '.native-ad-sponsorship,.native-ad-byline';
  let adElement = ad._element[0];
  const wrappedClickthroughUrl = getWrappedClickthrough(ad);
  if (adElement) {
    [...adElement.querySelectorAll(selector)].forEach(el => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function() {
        window.location = wrappedClickthroughUrl;
      });
    });
  }
}

/**
 * Get the GAM click tracking wrapped clickthrough url if available
 * If not, return the default clitkrhough url
 * @param {Object} ad
 * @returns {String}
 */
function getWrappedClickthrough(ad) {
  return ad.wrappedClickthroughUrl || ad.clickthroughUrl;
}

function updateLogo(adContainer, fields, key) {
  [...adContainer.querySelectorAll(adDataSelector(key))].forEach(el => {
    if (fields[key] && fields[key] !== 'null') {
      el.src = fields[key];
    }
    el.alt = fields.description;
  });
}

function updateThumbnail(adContainer, fields, key) {
  [...adContainer.querySelectorAll(adDataSelector(key))].forEach(el => {
    el.setAttribute('data-original', fields[key]);
    if (el.tagName === 'IMG') {
      if (fields[key] && fields[key] !== 'null') {
        el.src = fields[key];
      }

      el.alt = fields.description ? fields.description : 'Native Ad';
    } else {
      el.style.cssText = `background-image:url('${fields[key]}'); background-size: cover; background-repeat:no-repeat;`;
    }
  });
}

function findKeys(keys, text) {
  return keys.filter(key => key.includes(text));
}
